import { render, staticRenderFns } from "./nursedetail.vue?vue&type=template&id=299ee0b1&scoped=true&"
import script from "./nursedetail.vue?vue&type=script&lang=js&"
export * from "./nursedetail.vue?vue&type=script&lang=js&"
import style0 from "./nursedetail.vue?vue&type=style&index=0&id=299ee0b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ee0b1",
  null
  
)

export default component.exports